import {Accordion, AccordionDetails, AccordionSummary, Checkbox, Grid, Tooltip, Typography} from '@material-ui/core';
import * as React from 'react';
import {useState, useEffect} from 'react';
import {createStyles, makeStyles, Theme,alpha} from '@material-ui/core/styles';
import {white,primaryBlue} from 'src/components/colors';
import {AddIcon, DeleteIcon, EditIcon, ExpandMoreIcon} from 'src/components/Icons';


export function AddNewRoleAccordingList(props) {
  const classes = useStyles();
  const [show, setShow] = useState(-1)
  const openEdit = (i) => {
    if (i === show) {
      setShow(-1)
    } else {
      setShow(i)
    }
  }

  const handleDeleteIconClick = (id, privilege) => {
    props.onDelete(id, privilege)
  };

  return (
    <div style={{width: "100%"}}>
      {
        props.data.map((child, index) => {
          if (child && child.child) {
            return (
              <div key={index}>
                <Accordion expanded={show === index} elevation={0} key={index}
                  style={{backgroundColor: `rgba(124, 142, 150, ${props.opacity})`, paddingLeft: '20px'}}
                  TransitionProps={{unmountOnExit: true}} className={classes.subPrivilegeAccording}>
                  <AccordionSummary style={{ minHeight: "70px", paddingRight:'10px' }}
                    expandIcon={child.child && child.child.length > 0 ? <></> : <></>}
                    onClick={() => openEdit(index)}>
                    <Grid container>
                      <Grid item xs={3} md={3} style={{ display: "flex", alignItems: "center", justifyContent: 'center', fontSize: '0.9rem' }}>
                        <Grid container>
                          <Grid item xs={2} md={2} style={{ display: "flex", alignItems: "center" }}>
                            <input
                              type='checkbox'
                              style={{ display: 'inline-block' }}
                              className={classes.checkbox}
                              onChange={() => props.onChange(child)}
                              checked={child.selected == true}
                              onClick={(e) => e.stopPropagation()}
                              ref={el => { if (el) el.indeterminate = child.selected === 'partial'; }}
                            />
                          </Grid>
                          <Grid item xs={10} md={10} style={{ display: "flex", alignItems: "center" }}>
                            <Tooltip title={child.name} placement="bottom-start" arrow>
                              <Typography
                                style={{textTransform: 'capitalize', fontSize: '0.9rem' }}>{child.name.length > 20 ? (child.name.substring(0, 10) + "...").replace("_", " ") : child.name.replace("_", " ")}</Typography>
                            </Tooltip>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item md={7} xs={7} style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                        {child.actions ?
                          child.actions.map((action, actionIndex) => {
                            return (
                              <Grid key={actionIndex} style={{
                                display: 'flex',
                                alignItems: 'center',
                                fontFamily: 'poppins',
                                marginRight: '10px',
                                gap: '5px',
                                marginLeft: '0px',
                                fontSize: '0.9rem'
                              }}>
                                <Grid container>
                                  <Grid item>
                                    <input
                                      type='checkbox'
                                      style={{ display: 'inline-block' }}
                                      className={classes.checkbox}
                                      onChange={() => props.selectActionsFrom(child, action)}
                                      checked={action.selected == true}
                                      onClick={(e) => e.stopPropagation()}
                                      ref={el => { if (el) el.indeterminate = action.selected === 'partial'; }}
                                    />
                                  </Grid>
                                  <Grid item style={{display: 'flex', alignItems: 'center'}}>
                                    <Typography style={{fontFamily: 'poppins',fontSize:'0.8rem' }}>{action.action_name}</Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                            )
                          }) : <></>

                        }
                      </Grid>
                      <Grid item xs={2} md={2} style={{display: 'flex', alignItems: 'start', marginTop: "20px"}}>
                        <Grid container justifyContent='flex-end' spacing={1} 
                        className={
                          child.child && child.child.length > 0
                            ? classes.gridWithChild
                            : classes.gridWithoutChild
                        }>
                          <Grid item data-toggle='tooltip' title='Edit'
                                onClick={(e) => props.openAddNew(e, child.id, "edits", {
                                  name: child.name,
                                  id: child.id,
                                  description: child.description,
                                  actions: child.actions
                                })}
                          >
                            <EditIcon stroke={"#324054"}/>
                          </Grid>
                          <Grid item data-toggle='tooltip' title='Delete'
                                onClick={() => {
                                  handleDeleteIconClick(child.id, child)
                                }}
                          >
                            <DeleteIcon />
                          </Grid>
                          {child.child.length < 5 ?
                            <Grid item style={{ display: 'flex', justifyContent: 'end' }}
                              onClick={(e) => props.openAddNew(e, child.id, "add-new", undefined)}
                              onMouseEnter={() => props.onHover(child.id)}
                              onMouseLeave={() => props.removeHover()}
                              data-toggle='tooltip' title='Add Sub privilege'
                            >
                              <AddIcon fill={'none'} opacity={1}/>


                            </Grid>
                            :
                            <Grid item style={{ display: 'flex', justifyContent: 'end', cursor: 'default' }} data-toggle='tooltip' title='Disabled'>
                              <AddIcon aria-disabled="true" fill="none" opacity="0.5" />
                            </Grid>
                          }
                          
                            <Grid item style={{ cursor: 'pointer' }} onClick={() => openEdit(index)}>
                              {child.child && child.child.length > 0 && (<ExpandMoreIcon />)}
                            </Grid>
                        </Grid>

                      </Grid>
                    </Grid>
                  </AccordionSummary>
                  <AccordionDetails style={{backgroundColor: "white", padding: "0px"}}>
                    <Grid container style={{width: "100%"}}>
                      <AddNewRoleAccordingList allActions={props.allActions} onChange={(id) => props.onChange(id)}
                                               openAddNew={(e, i, type, defaultVal) => props.openAddNew(e, i, type, defaultVal)}
                                               data={child.child} opacity={props.opacity + 0.2} hover={props.hover}
                                               onHover={props.onHover} removeHover={props.removeHover}
                                               padding={props.padding > 11 ? props.padding : props.padding + 5}
                                               currentPrivileges={props.currentPrivileges}
                                               selectActionsFrom={(privilege, action) => props.selectActionsFrom(privilege, action)}
                                               onDelete={(id, privilege) => props.onDelete(id, privilege)} search={props.search}/>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              </div>
            );
          } else {
            return null;
          }
        })
      }
    </div>
  )
}

const useStyles = makeStyles((themes: Theme) =>
  createStyles({
    addHighPrivilegesAccording: {
      backgroundColor: "white",
      color: "black",
      marginLeft: "10px",
      marginRight: "10px",
      textTransform: "none",
      marginTop: "5px"
    },
    subIconButtonDiv: {
      backgroundColor: "white",
      width: "25px",
      height: "25px",
      borderRadius: "100%"
    },
    subPrivilegeAccording: {
      width: "100%",
      marginBottom: "1px"
    },
    iconBackground: {
      width: "24px",
      height: "24px",
      borderRadius: "100%",
      backgroundColor: "white"
    },
    checkbox:{
      '&.Mui-checked': {
        color: primaryBlue,
      },
      '&:hover': {
        backgroundColor: alpha(primaryBlue, 0.1),
      },
      '&.Mui-checked:hover': {
        backgroundColor: alpha(primaryBlue, 0.1),
      },
    },
    gridWithChild: {
      marginRight: 0,
    },
    gridWithoutChild: {
      marginRight: 25,
    },
  }),
);
